import { useNavigate } from "react-router-dom";

import { rand } from "../../utils";

import './index.css'

const errorScenes = [
    {
        title: 'Wrong Gate, Adventurer',
        description: 'This path leads to void data. The right route is one click away.',
        rune: '404'
    },
    {
        title: 'Map Fragment Missing',
        description: 'The page was not found in this shard. Return home to continue your quest.',
        rune: '??'
    },
    {
        title: 'Portal Misfired',
        description: 'Teleport coordinates failed. Head back to the central city and try again.',
        rune: '!'
    },
];

const ErrorComponent = () => {
    const navigate = useNavigate();
    const randomScene = errorScenes[rand(0, errorScenes.length - 1)];


    return (
        <div id='error-container'>
            <div id='error-card'>
                <div id='error-glyph' aria-hidden='true'>{randomScene.rune}</div>
                <h1 id='error-title'>{randomScene.title}</h1>
                <p id='error-description'>{randomScene.description}</p>
            </div>
            <button type="button" className='button'
                onClick={() => navigate("/")}
            >Go Home</button>
        </div>
    );
};

export default ErrorComponent;